export default __webpack_public_path__ + "static/media/jump_go.b04a731c.svg";